import { render } from "./MenuContentItemDivider.vue?vue&type=template&id=2f568308"
import script from "./MenuContentItemDivider.vue?vue&type=script&lang=js"
export * from "./MenuContentItemDivider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__